/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Show_CounterInputs */



/**
* | output |
* | --- |
* | "Show character counter" |
*
* @param {Live_Caption_Show_CounterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_show_counter = /** @type {((inputs?: Live_Caption_Show_CounterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Show_CounterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher le compteur de caractères")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeichenzähler anzeigen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mostra il contatore dei caratteri")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Показать счетчик символов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mostrar contador de caracteres")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("显示字符计数器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("文字数カウンターを表示")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैरेक्टर काउंटर दिखाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mostrar contador de caracteres")
	return /** @type {LocalizedString} */ ("Show character counter")
});